import { Flex } from 'antd';
import { BaseHeader } from 'components/header';
import { PrintableRootPage } from 'components/page/page-2';
import { PropsWithChildren } from 'react';
import { IntegrationImpactLayout } from './_components/layout';

export function PageIntegrationPilotContainer(
  props: PropsWithChildren<{ step: number }>
) {
  return (
    <IntegrationImpactLayout>
      <PrintableRootPage>
        <BaseHeader
          headerStyle={{
            background: 'none'
          }}
        />
        <Flex vertical gap={16}>
          {props.children}
        </Flex>
      </PrintableRootPage>
    </IntegrationImpactLayout>
  );
}
